import {
  ADMIN_SUMMARY_REPORT_V2_PATH,
  ADMIN_LEAGUE_REPORT_V2,
  EXPLORE_PATH
} from 'routes/paths'

type FloraTooltipTrigger = {
  id: string
  routeMatch: (pathname: string, hash: string) => boolean
  tooltipText: string
  chatMessage: string
}

const FLORA_CHAT_BASE_URL = '/app-v2/arvore-intelligence'

export const FLORA_TOOLTIP_TRIGGERS: FloraTooltipTrigger[] = [
  {
    id: 'search',
    routeMatch: pathname => pathname.startsWith(EXPLORE_PATH),
    tooltipText: 'Refine sua busca com sugestões personalizadas da Flora.',
    chatMessage: 'Me dê recomendações de leitura.'
  },
  {
    id: 'summary-overview-books',
    routeMatch: (pathname, hash) =>
      pathname === ADMIN_SUMMARY_REPORT_V2_PATH &&
      (hash === '#visao-geral' || hash === '#livros' || hash === ''),
    tooltipText: 'Analise esses dados com apoio da Flora.',
    chatMessage: 'Preciso de dados de acompanhamento.'
  },
  {
    id: 'summary-educators',
    routeMatch: (pathname, hash) =>
      pathname === ADMIN_SUMMARY_REPORT_V2_PATH && hash === '#educadores',
    tooltipText: 'Analise o engajamento dos educadores com apoio da Flora.',
    chatMessage: 'Quero acompanhar o uso da plataforma pelos educadores.'
  },
  {
    id: 'league-readers',
    routeMatch: pathname => pathname === ADMIN_LEAGUE_REPORT_V2,
    tooltipText: 'Crie estratégias para reconhecer seus leitores com a Flora.',
    chatMessage: 'Quero acessar os rankings de leitura.'
  }
]

export function buildFloraChatUrl(message: string): string {
  return `${FLORA_CHAT_BASE_URL}?message=${encodeURIComponent(message)}`
}

export function getActiveTooltipTrigger(
  pathname: string,
  hash: string
): FloraTooltipTrigger | null {
  return (
    FLORA_TOOLTIP_TRIGGERS.find(trigger =>
      trigger.routeMatch(pathname, hash)
    ) ?? null
  )
}
